var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"width":"375px","height":"auto","minHeight":"auto"},on:{"close":_vm.clearField}},[_c('div',{staticClass:"popup-sendPhone p-10 pb-11",attrs:{"slot":"body"},slot:"body"},[_c('send_request',{attrs:{"form_type":1,"user_info":_vm.user_info,"close":_vm.close},on:{"close":_vm.clearField}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }